/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getScanPersons = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Scan Person query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-scan-person/get?${queryString}`);
};

export const getScanPersonByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-scan-person/${id}`);
};

export const getScanPersonByMID = (mid) => {
  return API.get(`${getApiUrl()}/api/tkt1-scan-person/mid/${mid}`);
};

export const searchScanPersons = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Scan Person search query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-scan-person/search?${queryString}`);
};

export const createScanPerson = (scanPersonData) => {
  return API.post(`${getApiUrl()}/api/tkt1-scan-person/`, scanPersonData);
};

export const updateScanPerson = (id, scanPersonData) => {
  return API.put(`${getApiUrl()}/api/tkt1-scan-person/${id}`, scanPersonData);
};

export const deleteScanPerson = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-scan-person/${id}`);
};

export const tkt1ScanPersonService = {
  getScanPersons,
  getScanPersonByID,
  getScanPersonByMID,
  searchScanPersons,
  createScanPerson,
  updateScanPerson,
  deleteScanPerson
};
